import danmuHtml from './index.html'
import danmuControl from './danmu-control.html'
import danmuInput from './danmu-input.html'
import './index.scss'

import {parseDom, isElement} from "../utils";

/**
 * 弹幕组件
 */
export default class AliplayerDanmuComponent {

    constructor(danmukuList, sendEl = 'controlbar') {
        if (danmukuList)
            this.danmukuList = danmukuList
        else
            this.danmukuList = []
        this.html = parseDom(danmuHtml)
        this.CM = null
        this.userDanmuOpen = true     // 用户打开关闭弹幕的状态, 默认为 true 打开
    }

    createEl(el) {
        console.log(arguments);
        let videoSiblingElement = el.querySelector('video').nextElementSibling
        if (videoSiblingElement) {
            el.insertBefore(this.html, videoSiblingElement)
            // el.insertAfter(this.html, videoSiblingElement)
        } else {
            el.appendChild(this.html)
        }
        this.CM = new CommentManager(this.html.querySelector('.danmu'))     // 初始化 CommentManager

        this.CM.init()
        this.CM.load(this.danmukuList)

        let player = el.querySelector('video')

        /* 根据视频播放器的 timeupdate 事件更新弹幕的事件轴   */
        // el.querySelector('video')
        player.ontimeupdate = () => {
            if (el.querySelector('video') !== null) {
                // this.CM.time(el.querySelector('video').currentTime * 1000)
                this.CM.time(player.currentTime * 1000)
            }
        }
    }

    // 弹幕发送按钮点击事件和弹幕输入框按下 enter 键, 处理事件
    sendDanmuHandle() {
        let danmuInputEle = this.danmuInput.querySelector('.ali-danmu-input input')
        let danmuText = danmuInputEle.value
        this.sendTxt(danmuText)
        danmuInputEle.value = ''
        danmuInputEle.focus()
    }

    sendTxt(txt, color) {
        if (txt === '') {
            return
        }
        if (!color) {
            color = 0xffffff
        }
        let commentSize = [16, 18, 25, 36, 45]
        let commentColor = [0xffffff, 0x0000ff, 0xcc0000, 0xff66ff, 0xffff33]
        this.send({
            "mode": 1,
            "text": txt,
            "stime": 1000,
            // "size": commentSize[this.randomIndex(5)],
            // "color": commentColor[this.randomIndex(5)]
            "color": color,
            "size": 16
        })
    }

    randomIndex(max) {
        return Math.floor(Math.random() * max)
    }

    play(player, e) {
        if (this.userDanmuOpen) {
            this.CM.start()
        }
    }

    pause(player, e) {
        if (this.userDanmuOpen) {
            this.CM.stop()
        }
    }

    send(danmuku) {
        this.CM.send(danmuku)
    }

    /**
     * 暴露出去的插入弹幕的方法
     * @param {Object danmuku 弹幕对象 只能一条一条插入}
     */
    insert(danmuku) {
        this.CM && this.CM.insert(danmuku)
    }

    dispose() {
        if (this.danmuInput !== null) {
            this.danmuInput.parentNode && this.danmuInput.parentNode.removeChild(this.danmuInput)
        }
    }
}